import { attachDynamicEvent } from '~/common/helpers/dom'
import '../../../site/behaviors/simple_loader/index.scss'
import './index.scss'

const destroyAllEmbeds = () => {
  document
    .querySelectorAll('.simplero-embedded-order-form')
    ?.forEach((node) => node.remove())
  document.body.classList.remove('embedded-order-form-open')
}
const createEmbed = (purchaseUrl, classes, presentation = 'modal') => {
  destroyAllEmbeds()

  const presentationClass =
    presentation === 'sidebar' ? 'simplero-embedded-order-form--sidebar' : ''

  const html = `
    <div class="tw simplero-embedded-order-form ${presentationClass}">
      <div class="simplero-embedded-order-form__iframe__container ${classes}">
        <button type="button" class="popup-dismiss-button js-close-modal" aria-label="Close order form">
          <i class="fas fa-xmark s-icon"></i>
        </button>
        <iframe src="${purchaseUrl}"></iframe>
        <div class="simplero-embedded-order-form__loader__container">
          <div class="simple-loader"></div>
        </div>
      </div>
    </div>
  `
  document.body.insertAdjacentHTML('beforeend', html)

  const embed = document.querySelector('.simplero-embedded-order-form')
  embed.querySelector('iframe').addEventListener('load', () => {
    embed
      .querySelector('.simplero-embedded-order-form__loader__container')
      .remove()
  })
  requestAnimationFrame(() => {
    embed.classList.add('animate-in')
  })
  document.body.classList.add('embedded-order-form-open')
}

// Only close the popup when the dismiss button is explicitly clicked —
// never close on backdrop clicks or clicks outside the iframe.
attachDynamicEvent('.simplero-embedded-order-form', 'click', (e) => {
  if (e.target.closest('.js-close-modal')) {
    destroyAllEmbeds()
  }
})

export const openOrderFormInEmbed = (
  e,
  selector,
  classes,
  presentation = 'modal'
) => {
  e.preventDefault()

  const target = e.target.closest(selector)

  const url = new URL(target.href)
  if (!target.dataset.crossDomain) {
    url.host = window.location.host
  }
  createEmbed(url.toString(), classes, presentation)
}

const popupSelector = '[href*=purchase][href*=simplero_embedded_order_form]'
attachDynamicEvent(popupSelector, 'click', (e) => {
  openOrderFormInEmbed(e, popupSelector, 'one-click-container')
})

const sidebarSelector = '[href*=purchase][href*=simplero_sidebar_order_form]'
attachDynamicEvent(sidebarSelector, 'click', (e) => {
  openOrderFormInEmbed(e, sidebarSelector, '', 'sidebar')
})
